export default __webpack_public_path__ + "static/media/how-it-works-3.620b4c48.png";